<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="edit('')">新增</el-button>
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addAdmin">新增</el-button> -->
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="handleSolve">解除禁用</el-button>
	        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleForbid">禁用账户</el-button> -->
			</div>
		</template>
		<el-table v-loading="loading" ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%">
			<el-table-column prop="id" label="ID" width="40">
			</el-table-column>
			<el-table-column prop="birth_price" label="生日指引规则">
			</el-table-column>
			<el-table-column prop="point" label="生日返还积分倍数">
			</el-table-column>
			<el-table-column prop="start_time" label="开始时间">
			</el-table-column>
			<el-table-column prop="end_time" label="结束时间">
			</el-table-column>
			<el-table-column prop="end_time" label="状态">
				<template v-slot="scope">
					<el-tag style="cursor: pointer;" v-if="scope.row.status ==1" @click="changeStatus(scope.row.id,scope.row.status)">开启</el-tag>
					<el-tag style="cursor: pointer;" type="danger" v-else @click="changeStatus(scope.row.id,scope.row.status)">关闭</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="auto">
				<template #default="scope">
					<el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
					<!-- <el-button type="warning" size="mini" @click="del(scope.row)">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<!--总数超过一页，再展示分页器-->
		<!-- <el-pagination
	      background
	      layout="prev, pager, next"
	      :total="total"
	      :page-size="pageSize"
	      :current-page="currentPage"
	      @current-change="changePage"
	    /> -->
	</el-card>
	<el-dialog title="生日指引管理" v-model="dialogFormVisible">
		<el-form :model="form" ref='form' :rules="rules">
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="5">
						<label>生日指引</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.birth_price" prop="birth_price">
							<el-input v-model="form.birth_price" placeholder="生日指引" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="5">
						<label>积分倍数</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.point" prop="point">
							<el-input v-model="form.point" placeholder="积分倍数" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="5">
						<label>开始时间</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.start_time" prop="start_time">
							<el-input v-model="form.start_time" type="date" placeholder="开始时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="5">
						<label>结束时间</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.end_time" prop="end_time">
							<el-input v-model="form.end_time" type="date" placeholder="结束时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	export default{
		name:'BirthGuideList',
		data(){
			return {
				list: [],
				loading: false,
				dialogFormVisible: false,
				formLabelWidth: '120px',
				form: {
					birth_price: '',
					start_time:'',
					end_time:'',
					point:'',
				},
				rules:{
					birth_price: [{
						required: true,
						message: '会员指引不能为空',
						trigger: 'blur'
					}],
					point: [{
						required: true,
						message: '积分倍数不能为空',
						trigger: 'blur'
					}],
					start_time: [{
						required: true,
						message: '开始时间不能为空',
						trigger: 'blur'
					}],
					end_time: [{
						required: true,
						message: '结束时间不能为空',
						trigger: 'blur'
					}],
				}
			}
		},
		methods:{
			getBirthGuide(){
				this.httpPost({
					url: '/admin/birthguide/birth_guide_list',
					data: {
						routePath: this.$route.path
					}
				}).then((res) => {
					this.list = res.data;
				})
			},
			edit(val) {
				// console.log(val)
				this.dialogFormVisible = true;
				let temp = this.cloneObj(val);
					if (val) {
						this.form = temp;
					} else {
						this.resetObj(this.form)
					}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.updateBirthGuide();
					} else {
						console.log('error submit!')
						return false;
					}
				})
			},
			updateBirthGuide(){
				let temp = this.cloneObj(this.form);
				let id = temp.id;
				if (!id) id = '';
				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/birthguide/birth_guide_update?id=" + id,
					temp).then((data) => {
					// console.log(data);
				
					if (data.code == 1) {
						this.dialogFormVisible = false;
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							this.getBirthGuide();
						});
					} else {
						this.messageCommon('错误', data.msg, 'error');
					}
				});
			},
			changeStatus(id,status){
				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/birthguide/changeStatus", {
						id: id,
						status: status
					}).then((data) => {
					// console.log(data);
				
					if (data.code == 1) {
						this.dialogFormVisible = false;
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							this.getBirthGuide();
						});
					} else {
						this.messageCommon('错误', data.msg, 'error');
					}
				});
			}
		},
		created() {
			this.getBirthGuide();
		}
	}
</script>

<style>
</style>
